import { useMatch } from 'react-router-dom';

export const getDefaultSelectedMenuItem = () => {
  const accountMatch = useMatch('/settings/account');
  const usersMatch = useMatch('/settings/users/*');
  const notificationPrefsMatch = useMatch('/settings/notification-preferences');
  const applicationPrefsMatch = useMatch('/settings/application-preferences');

  if (accountMatch) return 'account-settings';
  if (usersMatch) return 'user-management';
  if (notificationPrefsMatch) return 'notification-preferences';
  if (applicationPrefsMatch) return 'application-preferences';

  return 'account-settings';
};
